import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ParentCollectComponent } from './collect/parent-collect.component';
import { ParentHomeComponent } from './home/parent-home.component';
import { ParentGuard } from './parent.guard';
import { ParentSignInComponent } from './signin/parent-signin.component';

const routes: Routes = [
  {
    path: 'parent',
    children: [
      {
        path: 'signin',
        component: ParentSignInComponent
      },
      {
        path: 'offline',
        component: ParentHomeComponent,
        data: { offline: true },
        canActivate: [ParentGuard]
      },
      {
        path: 'home',
        component: ParentHomeComponent,
        canActivate: [ParentGuard]
      },
      {
        path: 'collect/:patientID',
        component: ParentCollectComponent,
        canActivate: [ParentGuard]
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ParentRoutingModule { }
